// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AGCX Affiliate Program Page Styles
   File: affiliate-program.css
   ========================================================================== */

/* --- Main Page Layout & Container --- */
.affiliate-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 60px 0 100px 0;
    position: relative;
    overflow: hidden;
}



.affiliate-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.gold-text {
    color: #D3B06C;
}


/* ==========================================================================
   --- Hero Section ---
   ========================================================================== */
.affiliate-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    margin-bottom: 90px;
    position: relative;
    padding-top: 20px;
}

.affiliate-hero-left {
    flex: 1 1;
    max-width: 620px;
}

.affiliate-hero-title {
    font-size: 54px;
    font-weight: 700;
    color: #111827;
    line-height: 1.15;
    margin: 0 0 18px 0;
    letter-spacing: -0.5px;
}

.affiliate-hero-desc {
    font-size: 15px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 32px 0;
}

.affiliate-hero-btns {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 48px;
}

.affiliate-hero-btns a {
    padding: 14px 32px;
    font-size: 15px;
}

.btn-primary-gold2 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-weight: 600;
    padding: 14px 32px;
    font-size: 15px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    text-decoration: none;
}

.btn-primary-gold:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);
    color: #FFFFFF;
}

.btn-secondary-light {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background-color: #EFEFEF;
    color: #374151;
    font-weight: 600;
    border: 1px solid #E2E8F0;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
}

.btn-secondary-light:hover {
    background-color: #F1F5F9;
    color: #111827;
}

/* Hero Right Graphic Image */
.affiliate-hero-right {
    width: 600px;
    max-width: 100%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.affiliate-hero-right img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

/* Metric Stats Row Below Hero Buttons */
.affiliate-metrics-row {
    display: flex;
    align-items: center;
    gap: 20px;
}

.hero-stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 150px;
}

.hero-stat-icon {
    width: 44px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.hero-stat-icon img {
    width: 100%;
    object-fit: contain;
}

.hero-stat-value {
    font-size: 20px;
    font-weight: 800;
    color: #111827;
    line-height: 1.2;
    margin: 4px 0px;
}

.hero-stat-label {
    font-size: 14px;
    color: #9CA3AF;
    font-weight: 400;
}


/* ==========================================================================
   --- How to Earn Commissions Section ---
   ========================================================================== */
.affiliate-section {
    padding: 70px 0px;
    background-color: #F9FAFB;
}

.section-header-center2 {
    text-align: center;
    margin-bottom: 48px;
}

.section-header-center2 h2 {
    font-size: 42px;
    font-weight: 600;
    color: #111827;
    margin: 0;
    letter-spacing: 0.4px;
}

.steps-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.step-card2 {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 20px;
    padding: 48px 28px 32px 28px;
    text-align: center;
    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.05) !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.25s ease;
}

.step-card2:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);
    border-color: #E2E8F0;
}

.step-num-badge {
    width: 44px;
    height: 30px;
    border-radius: 20px;
    background-color: #D1AA67;
    color: #fff;
    position: absolute;
    top: -15px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.step-card-icon {
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.step-card-icon img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
}

.step-card2 h3 {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 10px 0;
}

.step-card2 p {
    font-size: 15px;
    color: #64748B;
    line-height: 1.6;
    margin: 0;
}


/* ==========================================================================
   --- Commission Banner Section ---
   ========================================================================== */
.commission-banner {
    background: linear-gradient(90deg, #FFF8EA 0%, #FFFFFF 100%);
    border: 1px solid #FDE68A;
    border-radius: 24px;
    padding: 42px 0px 42px 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin: 80px 0px;
    box-shadow: 0 4px 20px rgb(4 4 4 / 8%);
}

.commission-banner-content {
    max-width: 520px;
    z-index: 2;
}

.commission-subtitle {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #D3B06C;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
}

.commission-title {
    font-size: 40px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 14px 0;
    line-height: 1.2;
}

.commission-desc {
    font-size: 16px;
    color: #475569;
    line-height: 1.6;
    margin: 0 0 28px 0;
}

.commission-banner-image {
    width: 720px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.commission-banner-image img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   --- Why Become an AGCX Affiliate Section ---
   ========================================================================== */
.benefits-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}

.benefit-card {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 20px;
    padding: 32px 24px;
    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: all 0.25s ease;
}

.benefit-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);
    border-color: #E2E8F0;
}

.benefit-icon {
    width: 62px;
    height: 62px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.benefit-icon img {
    width: 100%;
    object-fit: contain;
}

.benefit-card h3 {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 10px 0;
}

.benefit-card p {
    font-size: 13px;
    color: #64748B;
    line-height: 1.55;
    margin: 0;
}


/* ==========================================================================
   --- Frequently Asked Questions Section ---
   ========================================================================== */
.faq-section {
    max-width: 100%;
    margin: 70px 0px;

}

.faq-accordion {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.faq-item {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgb(0 0 0 / 5%);
    transition: border-color 0.2s ease;
}

.faq-item.active {
    border-color: #E2E8F0;
}

.faq-question {
    width: 100%;
    padding: 23px 30px;
    background: none;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    cursor: pointer;
    text-align: left;
}

.faq-chevron {
    font-size: 20px;
    color: #D1AA67;
    transition: transform 0.25s ease;
}

.faq-item.active .faq-chevron {
    transform: rotate(180deg);
    color: #D3B06C;
}

.faq-answer {
    padding: 0 24px 20px 24px;
    color: #64748B;
    line-height: 1.65;
}

.faq-answer p {
    font-size: 17px;
}

/* ==========================================================================
   --- Responsive Adjustments ---
   ========================================================================== */

@media (max-width:1500px) {

    .affiliate-container {
        max-width: 95%;
    }

    .affiliate-hero-title {
        font-size: 48px;
    }

    .section-header-center2 h2 {
        font-size: 38px;
    }

}


@media (max-width: 1200px) {


    .affiliate-hero-right {
        width: 400px;
        max-width: 100%;
    }

    .affiliate-hero-btns {
        margin-bottom: 36px;
    }

    .hero-stat-value {
        font-size: 18px;
    }

    .affiliate-section {
        padding: 40px 0px;
    }

    .section-header-center2 h2 {
        font-size: 32px;
    }

    .commission-title {
        font-size: 32px;
    }

    .commission-desc {
        font-size: 14px;
        margin: 0 0 20px 0;
    }

    .affiliate-hero-btns a {
        padding: 10px 24px;
        font-size: 14px;
    }

    .affiliate-hero-title {
        font-size: 36px;
    }

    .affiliate-hero-desc {
        margin: 0 0 24px 0;
    }

    .affiliate-metrics-row {
        flex-wrap: wrap;
        gap: 24px;
    }

    .steps-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .benefits-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .commission-banner {
        padding: 40px;
        margin: 40px 0px;
    }

    .section-header-center2 {
        margin-bottom: 24px;
    }

    .faq-section {
        margin: 40px 0px;
    }

    .faq-question {
        padding: 16px 20px;
        font-size: 16px;
    }

    .faq-answer {
        padding: 0 20px 10px 20px;
    }


    .faq-answer p {
        font-size: 14px;
    }

}

@media (max-width: 991px) {


    .affiliate-hero-title {
        font-size: 32px;
        margin-bottom: 10px;
    }

    .affiliate-hero-right {
        width: 330px;
    }

    .btn-primary-gold2 {
        padding: 10px 26px;
        font-size: 14px;
    }

    .affiliate-hero {
        align-items: start;
        margin-bottom: 40px;
        padding-top: 0px;
    }

    .affiliate-hero-desc {
        margin: 0 0 20px 0;
    }

    .affiliate-hero-btns {
        flex-direction: column;
        align-items: stretch;
    }

    .affiliate-metrics-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    .commission-banner {
        gap: 30px;
        padding: 32px 24px;
    }

    .commission-banner-image {
        width: 100%;
        max-width: 100%;
    }

    .commission-title {
        font-size: 24px;
    }

    .section-header-center2 h2 {
        font-size: 24px;
    }

    .step-num-badge {
        width: 36px;
        font-size: 13px;
        height: 26px;
    }

    .affiliate-section {
        padding: 30px 0px;
    }


}


@media (max-width: 767px) {

    .affiliate-hero-title {
        font-size: 24px;
    }

    .affiliate-hero-left {
        text-align: center;
    }

    .affiliate-hero {
        flex-direction: column;
        margin-bottom: 30px;
    }

    .affiliate-hero-desc {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .affiliate-page {
        padding: 50px 0 50px 0;
    }

    .affiliate-metrics-row {
        gap: 12px;
    }

    .affiliate-hero-btns {
        margin-bottom: 20px;
    }

    .hero-stat-value {
        font-size: 16px;
    }

    .hero-stat-label {
        font-size: 12px;
    }

    .affiliate-hero-right {
        width: 280px;
        margin: 0 auto;
    }

    .steps-grid {
        grid-template-columns: repeat(1, 1fr);
        padding-top: 15px;
    }

    .commission-banner {
        flex-direction: column;
        gap: 24px;
        padding: 24px;
    }

    .benefits-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .section-header-center2 {
        margin-bottom: 18px;
    }

    .faq-section {
        margin: 35px 0px;
    }

    .commission-banner-content {
        max-width: 100%;
        text-align: center;
    }



}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AffiliateProgram/affiliate-program.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,yCAAyC;AACzC;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;AAGA;;+EAE+E;AAC/E;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,oDAAoD;IACpD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,4DAA4D;IAC5D,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;;+EAE+E;;AAE/E;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;;IAGI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;;IAGA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;;IAGI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;;AAGJ;;;AAGA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,qCAAqC;QACrC,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;;;AAIJ","sourcesContent":["/* ==========================================================================\n   AGCX Affiliate Program Page Styles\n   File: affiliate-program.css\n   ========================================================================== */\n\n/* --- Main Page Layout & Container --- */\n.affiliate-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 60px 0 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n\n\n.affiliate-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.gold-text {\n    color: #D3B06C;\n}\n\n\n/* ==========================================================================\n   --- Hero Section ---\n   ========================================================================== */\n.affiliate-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    margin-bottom: 90px;\n    position: relative;\n    padding-top: 20px;\n}\n\n.affiliate-hero-left {\n    flex: 1;\n    max-width: 620px;\n}\n\n.affiliate-hero-title {\n    font-size: 54px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.15;\n    margin: 0 0 18px 0;\n    letter-spacing: -0.5px;\n}\n\n.affiliate-hero-desc {\n    font-size: 15px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 32px 0;\n}\n\n.affiliate-hero-btns {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 48px;\n}\n\n.affiliate-hero-btns a {\n    padding: 14px 32px;\n    font-size: 15px;\n}\n\n.btn-primary-gold2 {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-weight: 600;\n    padding: 14px 32px;\n    font-size: 15px;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    text-decoration: none;\n}\n\n.btn-primary-gold:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);\n    color: #FFFFFF;\n}\n\n.btn-secondary-light {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    background-color: #EFEFEF;\n    color: #374151;\n    font-weight: 600;\n    border: 1px solid #E2E8F0;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-decoration: none;\n}\n\n.btn-secondary-light:hover {\n    background-color: #F1F5F9;\n    color: #111827;\n}\n\n/* Hero Right Graphic Image */\n.affiliate-hero-right {\n    width: 600px;\n    max-width: 100%;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.affiliate-hero-right img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n/* Metric Stats Row Below Hero Buttons */\n.affiliate-metrics-row {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.hero-stat-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 150px;\n}\n\n.hero-stat-icon {\n    width: 44px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n}\n\n.hero-stat-icon img {\n    width: 100%;\n    object-fit: contain;\n}\n\n.hero-stat-value {\n    font-size: 20px;\n    font-weight: 800;\n    color: #111827;\n    line-height: 1.2;\n    margin: 4px 0px;\n}\n\n.hero-stat-label {\n    font-size: 14px;\n    color: #9CA3AF;\n    font-weight: 400;\n}\n\n\n/* ==========================================================================\n   --- How to Earn Commissions Section ---\n   ========================================================================== */\n.affiliate-section {\n    padding: 70px 0px;\n    background-color: #F9FAFB;\n}\n\n.section-header-center2 {\n    text-align: center;\n    margin-bottom: 48px;\n}\n\n.section-header-center2 h2 {\n    font-size: 42px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n    letter-spacing: 0.4px;\n}\n\n.steps-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n}\n\n.step-card2 {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 20px;\n    padding: 48px 28px 32px 28px;\n    text-align: center;\n    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.05) !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transition: all 0.25s ease;\n}\n\n.step-card2:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);\n    border-color: #E2E8F0;\n}\n\n.step-num-badge {\n    width: 44px;\n    height: 30px;\n    border-radius: 20px;\n    background-color: #D1AA67;\n    color: #fff;\n    position: absolute;\n    top: -15px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.step-card-icon {\n    height: 65px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.step-card-icon img {\n    max-height: 100%;\n    width: auto;\n    object-fit: contain;\n}\n\n.step-card2 h3 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 10px 0;\n}\n\n.step-card2 p {\n    font-size: 15px;\n    color: #64748B;\n    line-height: 1.6;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   --- Commission Banner Section ---\n   ========================================================================== */\n.commission-banner {\n    background: linear-gradient(90deg, #FFF8EA 0%, #FFFFFF 100%);\n    border: 1px solid #FDE68A;\n    border-radius: 24px;\n    padding: 42px 0px 42px 42px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    margin: 80px 0px;\n    box-shadow: 0 4px 20px rgb(4 4 4 / 8%);\n}\n\n.commission-banner-content {\n    max-width: 520px;\n    z-index: 2;\n}\n\n.commission-subtitle {\n    display: block;\n    font-size: 12px;\n    font-weight: 700;\n    color: #D3B06C;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 8px;\n}\n\n.commission-title {\n    font-size: 40px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 14px 0;\n    line-height: 1.2;\n}\n\n.commission-desc {\n    font-size: 16px;\n    color: #475569;\n    line-height: 1.6;\n    margin: 0 0 28px 0;\n}\n\n.commission-banner-image {\n    width: 720px;\n    max-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.commission-banner-image img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   --- Why Become an AGCX Affiliate Section ---\n   ========================================================================== */\n.benefits-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n}\n\n.benefit-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 20px;\n    padding: 32px 24px;\n    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    transition: all 0.25s ease;\n}\n\n.benefit-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);\n    border-color: #E2E8F0;\n}\n\n.benefit-icon {\n    width: 62px;\n    height: 62px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.benefit-icon img {\n    width: 100%;\n    object-fit: contain;\n}\n\n.benefit-card h3 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 10px 0;\n}\n\n.benefit-card p {\n    font-size: 13px;\n    color: #64748B;\n    line-height: 1.55;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   --- Frequently Asked Questions Section ---\n   ========================================================================== */\n.faq-section {\n    max-width: 100%;\n    margin: 70px 0px;\n\n}\n\n.faq-accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.faq-item {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 1px 4px rgb(0 0 0 / 5%);\n    transition: border-color 0.2s ease;\n}\n\n.faq-item.active {\n    border-color: #E2E8F0;\n}\n\n.faq-question {\n    width: 100%;\n    padding: 23px 30px;\n    background: none;\n    border: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n    cursor: pointer;\n    text-align: left;\n}\n\n.faq-chevron {\n    font-size: 20px;\n    color: #D1AA67;\n    transition: transform 0.25s ease;\n}\n\n.faq-item.active .faq-chevron {\n    transform: rotate(180deg);\n    color: #D3B06C;\n}\n\n.faq-answer {\n    padding: 0 24px 20px 24px;\n    color: #64748B;\n    line-height: 1.65;\n}\n\n.faq-answer p {\n    font-size: 17px;\n}\n\n/* ==========================================================================\n   --- Responsive Adjustments ---\n   ========================================================================== */\n\n@media (max-width:1500px) {\n\n    .affiliate-container {\n        max-width: 95%;\n    }\n\n    .affiliate-hero-title {\n        font-size: 48px;\n    }\n\n    .section-header-center2 h2 {\n        font-size: 38px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n    .affiliate-hero-right {\n        width: 400px;\n        max-width: 100%;\n    }\n\n    .affiliate-hero-btns {\n        margin-bottom: 36px;\n    }\n\n    .hero-stat-value {\n        font-size: 18px;\n    }\n\n    .affiliate-section {\n        padding: 40px 0px;\n    }\n\n    .section-header-center2 h2 {\n        font-size: 32px;\n    }\n\n    .commission-title {\n        font-size: 32px;\n    }\n\n    .commission-desc {\n        font-size: 14px;\n        margin: 0 0 20px 0;\n    }\n\n    .affiliate-hero-btns a {\n        padding: 10px 24px;\n        font-size: 14px;\n    }\n\n    .affiliate-hero-title {\n        font-size: 36px;\n    }\n\n    .affiliate-hero-desc {\n        margin: 0 0 24px 0;\n    }\n\n    .affiliate-metrics-row {\n        flex-wrap: wrap;\n        gap: 24px;\n    }\n\n    .steps-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .benefits-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .commission-banner {\n        padding: 40px;\n        margin: 40px 0px;\n    }\n\n    .section-header-center2 {\n        margin-bottom: 24px;\n    }\n\n    .faq-section {\n        margin: 40px 0px;\n    }\n\n    .faq-question {\n        padding: 16px 20px;\n        font-size: 16px;\n    }\n\n    .faq-answer {\n        padding: 0 20px 10px 20px;\n    }\n\n\n    .faq-answer p {\n        font-size: 14px;\n    }\n\n}\n\n@media (max-width: 991px) {\n\n\n    .affiliate-hero-title {\n        font-size: 32px;\n        margin-bottom: 10px;\n    }\n\n    .affiliate-hero-right {\n        width: 330px;\n    }\n\n    .btn-primary-gold2 {\n        padding: 10px 26px;\n        font-size: 14px;\n    }\n\n    .affiliate-hero {\n        align-items: start;\n        margin-bottom: 40px;\n        padding-top: 0px;\n    }\n\n    .affiliate-hero-desc {\n        margin: 0 0 20px 0;\n    }\n\n    .affiliate-hero-btns {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .affiliate-metrics-row {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px;\n    }\n\n    .commission-banner {\n        gap: 30px;\n        padding: 32px 24px;\n    }\n\n    .commission-banner-image {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .commission-title {\n        font-size: 24px;\n    }\n\n    .section-header-center2 h2 {\n        font-size: 24px;\n    }\n\n    .step-num-badge {\n        width: 36px;\n        font-size: 13px;\n        height: 26px;\n    }\n\n    .affiliate-section {\n        padding: 30px 0px;\n    }\n\n\n}\n\n\n@media (max-width: 767px) {\n\n    .affiliate-hero-title {\n        font-size: 24px;\n    }\n\n    .affiliate-hero-left {\n        text-align: center;\n    }\n\n    .affiliate-hero {\n        flex-direction: column;\n        margin-bottom: 30px;\n    }\n\n    .affiliate-hero-desc {\n        font-size: 14px;\n        margin-bottom: 15px;\n    }\n\n    .affiliate-page {\n        padding: 50px 0 50px 0;\n    }\n\n    .affiliate-metrics-row {\n        gap: 12px;\n    }\n\n    .affiliate-hero-btns {\n        margin-bottom: 20px;\n    }\n\n    .hero-stat-value {\n        font-size: 16px;\n    }\n\n    .hero-stat-label {\n        font-size: 12px;\n    }\n\n    .affiliate-hero-right {\n        width: 280px;\n        margin: 0 auto;\n    }\n\n    .steps-grid {\n        grid-template-columns: repeat(1, 1fr);\n        padding-top: 15px;\n    }\n\n    .commission-banner {\n        flex-direction: column;\n        gap: 24px;\n        padding: 24px;\n    }\n\n    .benefits-grid {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .section-header-center2 {\n        margin-bottom: 18px;\n    }\n\n    .faq-section {\n        margin: 35px 0px;\n    }\n\n    .commission-banner-content {\n        max-width: 100%;\n        text-align: center;\n    }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
